import { render, staticRenderFns } from "./download2.vue?vue&type=template&id=b1943704&scoped=true&"
import script from "./download2.vue?vue&type=script&lang=js&"
export * from "./download2.vue?vue&type=script&lang=js&"
import style0 from "./download2.vue?vue&type=style&index=0&id=b1943704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1943704",
  null
  
)

export default component.exports